import {
  FaLeaf,
  FaTree,
  FaMountain,
  FaCampground,
  FaFire,
  FaWater,
  FaSun,
  FaMoon,
  FaCloudSun,
  FaCloudMoon,
  FaSnowflake,
  FaSeedling,
  FaPaw,
  FaFish,
  FaCompass,
  FaBinoculars,
  FaBed,
  FaCouch,
  FaBath,
  FaShower,
  FaHome,
  FaDoorOpen,
  FaLightbulb,
  FaFan,
  FaMugHot,
  FaCoffee,
  FaUtensils,
  FaWineGlass,
  FaGlassCheers,
  FaWifi,
  FaSwimmingPool,
  FaSpa,
  FaParking,
  FaChargingStation,
  FaConciergeBell,
  FaShoppingBag,
  FaStore,
  FaTicketAlt,
  FaGift,
  FaHiking,
  FaBicycle,
  FaRunning,
  FaSwimmer,
  FaCamera,
  FaGamepad,
  FaMusic,
  FaGuitar,
  FaBook,
  FaMapMarkedAlt,
  FaMapMarkerAlt,
  FaCar,
  FaBus,
  FaMotorcycle,
  FaShuttleVan,
  FaPlane,
  FaShip,
  FaWalking,
  FaShieldAlt,
  FaFirstAid,
  FaPhone,
  FaBell,
  FaClock,
  FaStar,
  FaCheckCircle,
  FaInfoCircle,
  FaHandsHelping,
} from "react-icons/fa";

export const HOME_ICON_OPTIONS = [
  "FaLeaf",
  "FaTree",
  "FaMountain",
  "FaCampground",
  "FaFire",
  "FaWater",
  "FaSun",
  "FaMoon",
  "FaStar",
  "FaMapMarkerAlt",
  "FaWifi",
  "FaCoffee",
  "FaUtensils",
  "FaBed",
  "FaShower",
  "FaCar",
  "FaHiking",
  "FaBicycle",
  "FaSwimmingPool",
  "FaSpa",
];

export const ICON_MAP = {
  FaLeaf,
  FaTree,
  FaMountain,
  FaCampground,
  FaFire,
  FaWater,
  FaSun,
  FaMoon,
  FaCloudSun,
  FaCloudMoon,
  FaSnowflake,
  FaSeedling,
  FaPaw,
  FaFish,
  FaCompass,
  FaBinoculars,
  FaBed,
  FaCouch,
  FaBath,
  FaShower,
  FaHome,
  FaDoorOpen,
  FaLightbulb,
  FaFan,
  FaMugHot,
  FaCoffee,
  FaUtensils,
  FaWineGlass,
  FaGlassCheers,
  FaWifi,
  FaSwimmingPool,
  FaSpa,
  FaParking,
  FaChargingStation,
  FaConciergeBell,
  FaShoppingBag,
  FaStore,
  FaTicketAlt,
  FaGift,
  FaHiking,
  FaBicycle,
  FaRunning,
  FaSwimmer,
  FaCamera,
  FaGamepad,
  FaMusic,
  FaGuitar,
  FaBook,
  FaMapMarkedAlt,
  FaMapMarkerAlt,
  FaCar,
  FaBus,
  FaMotorcycle,
  FaShuttleVan,
  FaPlane,
  FaShip,
  FaWalking,
  FaShieldAlt,
  FaFirstAid,
  FaPhone,
  FaBell,
  FaClock,
  FaStar,
  FaCheckCircle,
  FaInfoCircle,
  FaHandsHelping,
};

const ICON_OPTIONS = Object.keys(ICON_MAP).sort();